import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const shifts = [
  {
    day: "Tuesday",
    start: "14:00",
    end: "22:00",
    label: "Gaufres",
    with: "Lisa, Alex",
    color: "bg-rose-300",
    border: "border-green-600", // terminé
    icon: "🍩"
  },
  {
    day: "Thursday",
    start: "11:00",
    end: "17:00",
    label: "Bar",
    with: "Sarah, Mike",
    color: "bg-sky-300",
    border: "border-yellow-400 border-dashed", // en attente
    icon: "🍸"
  },
  {
    day: "Thursday",
    start: "17:00",
    end: "23:00",
    label: "Service",
    with: "John, Emma, John",
    color: "bg-pink-300",
    border: "",
    icon: "🍽️"
  },
  {
    day: "Saturday",
    start: "10:00",
    end: "16:00",
    label: "Plonge",
    with: "Tom",
    color: "bg-green-400",
    border: "",
    icon: "🧼"
  },
  {
    day: "Sunday",
    start: "10:00",
    end: "17:00",
    label: "Salle VIP",
    with: "Claire, David",
    color: "bg-indigo-500",
    border: "",
    icon: "⭐"
  }
];

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const hours = Array.from({ length: 19 }, (_, i) => `${(6 + i).toString().padStart(2, '0')}:00`);
const hourSlotHeight = 66.66;
const minutesPerSlot = 60;
const pixelsPerMinute = hourSlotHeight / minutesPerSlot;

const timeToMinutes = (time) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

const formatDuration = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  return `${hours}h`;
};

export default function Planning() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <main className="max-w-7xl mx-auto px-6 py-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Mon planning</h1>
            <p className="text-sm text-gray-500">Mai 1–7, 2025</p>
          </div>
          <div className="flex items-center space-x-2 text-gray-500">
            <button><ChevronLeft className="w-5 h-5" /></button>
            <button><ChevronRight className="w-5 h-5" /></button>
          </div>
        </div>

        {/* Planning grid */}
        <div className="overflow-hidden border rounded-xl bg-white shadow-sm">
          {/* Header row */}
          <div className="grid grid-cols-8 border-b text-sm text-gray-600 font-medium">
            <div className="p-3 bg-gray-50"></div>
            {days.map((day) => (
              <div key={day} className="p-3 text-center">{day}</div>
            ))}
          </div>

          {/* Content grid */}
          <div className="grid grid-cols-8 relative text-xs h-[1266px]">
            {/* Hours column */}
            <div className="border-r bg-gray-50 text-right text-gray-400">
              {hours.map((hour) => (
                <div key={hour} className="h-[66.66px] pr-3 pt-1">{hour}</div>
              ))}
            </div>

            {/* Day columns */}
            {days.map((day) => (
              <div key={day} className="border-r relative">
                {shifts
                  .filter((shift) => shift.day === day)
                  .map((shift, index) => {
                    const start = timeToMinutes(shift.start);
                    const end = timeToMinutes(shift.end);
                    const top = (start - 360) * pixelsPerMinute; // starts at 06:00
                    const height = (end - start) * pixelsPerMinute;
                    const duration = formatDuration(end - start);

                    return (
                      <div
                        key={index}
                        className={`absolute left-2 right-2 rounded-xl p-2 text-white text-xs shadow-md flex flex-col justify-between ${shift.color} ${shift.border}`}
                        style={{ top, height }}
                      >
                        <div className="flex items-center gap-1 font-semibold">
                          <span>{shift.icon}</span>
                          <span>{shift.label}</span>
                        </div>
                        <div className="text-[10px] opacity-90">
                          {shift.start} - {shift.end}<br />
                          <span className="text-white/80">With: {shift.with}</span>
                        </div>
                        <div className="text-[10px] text-right">{duration}</div>
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>
        </div>

        {/* Légende */}
        <div className="flex items-center gap-4 text-xs text-gray-500 mt-4">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 border-2 border-dashed border-yellow-400 rounded-full" />
            <span>Traitement en attente</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 border-2 border-green-600 rounded-full" />
            <span>Traitement terminé</span>
          </div>
        </div>
      </main>
    </div>
  );
}
